import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { Requisition } from '../../models/inventory/requisition';
import { ApiResponse, EntityKeyByReference } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class RequisitionProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.inventoryApi}/api/v1/requisition`;

  getByEntityKey(entityKey: EntityKeyByReference, includeClosed = false, includeLotItems = false): Observable<ApiResponse<Requisition[]>> {
    return this.httpClient.post<ApiResponse<Requisition[]>>(
      `${this.baseUrl}/entity-key?includeClosed=${includeClosed}&includeLotItems=${includeLotItems}`,
      entityKey,
    );
  }
}
